var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('search-panel',{attrs:{"showLocationSelect":false,"locations":[_vm.location],"locationStats":[_vm.locationStats]}})}
var staticRenderFns = []

export { render, staticRenderFns }